import React from "react"
import { LinkButton } from "./styled"
import { CrossCompanyPhoneCheck } from "./auth/CrossCompanyPhoneCheck"
import { saniziteRawHtml } from "../utils/Helpers"
import ReactHtmlParser from "react-html-parser"

export const GetStartedComponent = (props) => {
  const initialValues = {
    phoneNumber: ""
  }  

  return (
    <section>
      <div className="container hero3">
        {ReactHtmlParser(saniziteRawHtml(props.frontDoorLandingText1))}    
        {props.sprintRedirectActive ? (
          <div className="mx-auto col-md-4">
            <CrossCompanyPhoneCheck initialValues={initialValues} />
          </div>
        ) : (
          <div className="row text-center">
            <div className="mx-auto col-md-10">
              <LinkButton className="btn" id="btnSubmit"
                href={process.env.REACT_APP_TMO_ID_AUTH_URL} 
                onClick={() =>   sessionStorage.setItem("isFromStandardPage", true)}
                primary>Continue</LinkButton>
            </div>
          </div>
        )}
        {ReactHtmlParser(saniziteRawHtml(props.frontDoorLandingText2))}
      </div>
    </section>
  );
}
